module.exports = __webpack_public_path__ + "static/media/14.b08a9252.jpg";